/**
 * 禁用词
 */
import ToolkitApi from '../../api/toolkit.api'
const commonStopword = new ToolkitApi('stopword');
import stopwordApi from '../../api/stopword.api'
import stopwordImgApi from '../../api/stopword.image.api'
import payApi from '../../api/pay.api'
import http from "../../api/http";

const state = {
    detailVisible: false,
    url: '',
    token: '',
    type: 0 // 类型0：文字，1：图片
};

const getters = {
    // 下载纯文字检测word文档
    downloadWordUrl: () => id => {
        return stopwordApi.downloadWord(id);
    }
};

const mutations = {
    // 设置检测参数
    setState(state, data) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                state[key] = data[key];
            }
        }
    }
};

const actions = {
    //启动检测
    start({state, commit}, params) {
        commonStopword.namespace = params.type ? 'stopwordImg' : 'stopword';
        return commonStopword.start(params).then(res => {
            commit('setState', {url: params.url, token: res.token});
            return res;
        })
    },
    // 启动单页检测
    startSingle({state, commit}, params) {
        return stopwordApi.startSingle(params).then(res => {
            commit('setState', {url: params.url, token: res.token});
            return res;
        })
    },
    // 启动纯文字检测
    startText({}, content) {
        return stopwordApi.startText(content);
    },
    //获取进度数据
    getProgress({state}) {
        return commonStopword.getProgress(state.token);
    },
    //获取结果数据
    getList({state}) {
        return commonStopword.getList(state.token);
    },
    //取消检测
    cancel({state}) {
        return commonStopword.cancel(state.token);
    },
    // 是否满足下载报告的条件（已支付&&已有最新报告）
    canReportText ({state}, productId) {
        return stopwordApi.canReportText({
            productId,
            token: state.token,
            url: state.url
        });
    },
    //生成报告
    createReport({state}) {
        return stopwordApi.createReport(state.token);
    },
    // 下载报告
    downloadReport({state, rootState}) {
        return commonStopword.downloadReport({userId: rootState.user._id, token: state.token, phone: rootState.user.phone});
    },
    // 提交违禁词服务表单
    submitServiceForm({state}, params) {
        params.token = state.token;
        return stopwordApi.submitServiceForm(params);
    },
    // 抵用券
    useVoucherCode({}, code) {
        return stopwordApi.useVoucherCode(code);
    },
    // 添加订单
    addOrderForm({state}, productId) {
        return payApi.addOrderForm({
            productId,
            token: state.token,
            url: state.url
        });
    },
    //启动图片检测2阶段
    startImage({state}) {
        return stopwordImgApi.startImage(state.token);
    },
    //清除图片检测缓存数据
    clearImage({state}) {
        return stopwordImgApi.clearImage(state.token);
    },
    //导出死链csv
    downloadXenuCSV({state}) {
        return commonStopword.downloadXenuCSV(state.token);
    },
    //是否已经支付(禁用词图片)
    isCompletePay_ad2({state}) {
        return stopwordImgApi.isCompletePay_ad2({
            token: state.token
        });
    },
    //添加订单(禁用词图片)
    addOrderForm_ad2({state}, quantity) {
        return stopwordImgApi.addOrderForm_ad2({
            token: state.token,
            url: state.url,
            quantity
        });
    },
    // 获取纯文字检测累计数据
    getAccumulative() {
        return stopwordApi.getAccumulative();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/stopword.js